import { object } from 'prop-types';
import React, { useEffect, useCallback } from 'react';
import { StandardButton } from '@eika/button';
import connect from '../../helper/connect';
import { FRA_UTLAND_TYPE, tilUtland, TIL_UTLAND_TYPE } from './helper';
import InternasjonaleOverforing from './overforing';
import { getInternasjonaleOverforingerFields, isValidOverforingField } from './validation';
import getLabel from '../labels';

const InternasjonaleOverforingerQuestionType = (props) => {
    const { context, question } = props;
    const subquestions = context.getValue(question.definisjon);

    const defineTextType = (definisjon) => {
        return tilUtland.includes(definisjon);
    };

    const addAnswer = useCallback(() => {
        const id = `${Math.random()}`.slice(2).padEnd(20, 0);

        const currentValue = context.getValue(question.definisjon);
        const newState = [
            ...currentValue,
            {
                id,
                type: defineTextType(props.question.rootQuestion) ? TIL_UTLAND_TYPE : FRA_UTLAND_TYPE,
                error: true,
                touched: false,
                ...getInternasjonaleOverforingerFields(),
            },
        ];

        context.onChange(question.definisjon, { value: newState });
    }, [context, props.question.rootQuestion, question.definisjon]);

    useEffect(() => {
        if (subquestions.length === 0) {
            addAnswer();
        }
    }, [addAnswer, subquestions.length]);

    const getErrorList = (props) => {
        const keys = Object.keys(getInternasjonaleOverforingerFields());
        return keys.filter((key) => (isValidOverforingField(key, props[key]) ? false : key));
    };

    const getShowErrors = () => props.context.getHasSubmitted();

    const removeAnswer = (id) => {
        const newState = [...context.getValue(question.definisjon)];
        const idx = newState.findIndex((ans) => ans.id === id);
        newState.splice(idx, 1);

        context.onChange(question.definisjon, { value: newState });
    };

    const changeAnswer = (id, patch) => {
        const newState = context.getValue(question.definisjon).map((el) => {
            const newAns = { ...el, ...patch };
            const hasError = getShowErrors() ? getErrorList(newAns).length > 0 : false;
            return el.id === id ? { ...newAns, error: hasError } : el;
        });
        context.onChange(question.definisjon, { value: newState });
    };

    return (
        <div className="crs-skjema">
            <div className="crs-underskjema">
                {subquestions.map((subquestion, index) => (
                    <InternasjonaleOverforing
                        key={`answer_${subquestion.id}`}
                        question={subquestion}
                        onChange={changeAnswer}
                        onRemove={removeAnswer}
                        tilUtland={defineTextType(question.rootQuestion)}
                        index={index}
                        ekstratekster={question.ekstratekster || {}}
                        errors={getErrorList(subquestion)}
                    />
                ))}
            </div>
            <StandardButton id="rr-add-skatterelasjon" onClick={addAnswer}>
                <i className="ikon-pluss-24" />
                {getLabel(question.ekstratekster || {}, 'add_country')}
            </StandardButton>
        </div>
    );
};

InternasjonaleOverforingerQuestionType.propTypes = {
    question: object.isRequired,
    context: object,
};

export default connect(React.memo(InternasjonaleOverforingerQuestionType));
